<script lang="ts" setup>
defineProps({
  recommendedPrice: {
    type: Object as PropType<BasePrice>,
    required: false,
    default: null,
  },
});
</script>

<template>
  <div class="relative flex items-center w-fit">
    <NuxtIcon
      name="mdi:information"
      alt="icon of information"
      class="text-neutral-300 w-5 h-5 peer" />
    <CommonTooltip position="top">
      <template #tooltip-text>
        <p class="text-xs text-black font-semibold">
          {{
            $t("main.cardCollectible.recommendedPrice").charAt(0) +
            $t("main.cardCollectible.recommendedPrice").slice(1).toLowerCase()
          }}:
        </p>
        <p class="text-xs text-primary-600 font-bold">
          {{ roundNum(recommendedPrice?.GFAL) }} GFAL
        </p>
        <p class="text-[10px] text-neutral-300">
          {{ roundNum(recommendedPrice?.USD) }} USD
        </p>
      </template>
    </CommonTooltip>
  </div>
</template>
